
import { defineComponent, computed } from 'vue';
import PrimaryButton from '@/components/global/PrimaryButton.vue';
import ExplorerButton from './ExplorerButton.vue';
import { FILTERABLE_COLUMNS, getDefaultFilterValue } from './explorerColumns';

export default defineComponent({
  components: { ExplorerButton, PrimaryButton },
  props: {
    showFilters: { type: Boolean, required: true },
    filterValues: { type: Object, required: true },
  },
  emits: ['toggle-filters', 'reset-filters'],
  setup(props) {
    // Vergleiche alle Filterwerte mit den Defaultwerten
    const isResetDisabled = computed(() => FILTERABLE_COLUMNS.every((col) => {
      const def = getDefaultFilterValue(col, col.max ?? 0);
      const val = props.filterValues[col.key];
      return val && val[0] === def[0] && val[1] === def[1];
    }));
    return { isResetDisabled };
  },
});
